<div class="family-item-root" *transloco="let t">
  <span class="normal-text">{{ familyData.name }}</span>
  <span class="normal-text">{{ familyData.quantityOfProducts ?? 0}}</span>
  <span class="normal-text">{{ familyData.vipQuantity ?? 0 }}</span>
  <div>
    <button class="action-button"
            mat-icon-button
            (click)="openEditFamilyModal($event)"
            [matTooltip]="t('family-list.edit-vip-tooltip')">
      <nb-icon icon="pricetags-outline"></nb-icon>
    </button>
    <button class="action-button"
            mat-icon-button
            (click)="openEditPromoTextModal($event)"
            [matTooltip]="t('family-list.promo-text-tooltip')">
      <nb-icon icon="file-text-outline"></nb-icon>
    </button>
  </div>
</div>
<div class="family-item-divider"></div>
